import { useSearchParams } from 'react-router-dom';
export const useUpdateSearchParams = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const updateSearchParams = (params) => {
        setSearchParams((prev) => {
            params.forEach((param) => {
                if (!param.value) {
                    prev.delete(param.key);
                }
                else {
                    prev.set(param.key, String(param.value));
                }
            });
            return prev;
        });
    };
    return { updateSearchParams, searchParams };
};
